import {
    AnyAction,
    Dispatch,
    Middleware,
} from '@reduxjs/toolkit'
import {NinchatProperties} from '../../api/types'
import {batch} from 'react-redux'
import {ninchatEventActions} from 'api/slice'

export const batchAction = new Set<NinchatProperties.ActionID | undefined>()
const batchQueue = new Set<AnyAction>()
const batchStuck = new Set<NinchatProperties.ActionID | undefined>()

let flushID: ReturnType<typeof setTimeout> // eslint-disable-line init-declarations
let failsafeID: ReturnType<typeof setTimeout> // eslint-disable-line init-declarations

const flush = () => (dispatch: Dispatch) => {
    batch(() => {
        for (const action of batchQueue) {
            dispatch(action)

            batchQueue.delete(action)
        }
    })
}

const failsafe = () => (dispatch: Dispatch) => {
    if (batchStuck.size) {
        for (const action of batchStuck) {
            if (batchAction.has(action)) {
                batchAction.delete(action)
                console.warn(`batch action failsafe clear action id ${action}`)
            }
            batchStuck.delete(action)
        }
    }

    if (batchQueue.size) {
        flush()(dispatch)
    }


    if (batchAction.size) {
        for (const action of batchAction) {
            batchStuck.add(action)
        }

        failsafeID = setTimeout(() => failsafe()(dispatch), 20000)
    }
}

export const batchMiddleware: Middleware = () => (next) => (action) => {
    if (batchAction.size) {
        if (action.type === ninchatEventActions.error.type) {
            if (batchAction.has(action.meta.event.action_id)) {
                batchAction.delete(action.meta.event.action_id)

                console.warn(`batch action ${action.payload.message} error action id ${action.meta.event.action_id}`)
                return undefined
            }
        }

        if (batchAction.has(action.payload.action_id)) {
            clearTimeout(flushID)
            clearTimeout(failsafeID)

            failsafeID = setTimeout(() => failsafe()(next), 10000)

            batchQueue.add(action)
            batchAction.delete(action.payload.action_id)

            if (!batchAction.size && batchQueue.size) {
                flush()(next)
                clearTimeout(failsafeID)
            } else {
                flushID = setTimeout(() => flush()(next), 1000)
            }

            return undefined
        }
    }

    return next(action)
}
